import React from 'react';
import { EsgBriefcase } from "assets";
import { MRT_ColumnDef } from 'material-react-table';
import { capitalizeString, formatFriendlyDate } from 'utils';
import { Box, CircularProgress } from '@mui/material';

export const JOBS_PAGE = {
  ABSOLUTE_PATH: "/jobs",
  PATH: "",
  TITLE: "Jobs",
  ICON: <EsgBriefcase />,
  renderMenu: false,
};

export const jobsColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Job Name',
    Cell: ({ cell }) => {
      let value = cell.getValue<string>();

      if (value?.includes('_')) {
        value = value.split('_').join(' ');
        value = capitalizeString(value) as string;
      }

      return value;
    },
  },
  {
    accessorKey: 'createDate',
    header: 'Date',
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();

      return (
        <div>
          <span>{formatFriendlyDate(value, true)}</span>
        </div>
      );
    },
    sortingFn: (rowA, rowB) => {
      const dateA = new Date(rowA.original.createDate).getTime();
      const dateB = new Date(rowB.original.createDate).getTime();

      return dateA - dateB;
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    Cell: ({ cell }) => {
      const statusValue = cell.getValue() as string;

      const statusParser: any = {
        processing: 'IN_PROGRESS',
        pending: 'IN_PROGRESS',
        in_progress: 'IN_PROGRESS',
        error: 'BLOCKED',
        processed: 'DONE',
        uploaded: 'DONE',
        success: 'DONE',
      };

      if (!statusValue) return '';

      const statusIdParsed: string = statusParser[`${statusValue.toLowerCase()}`];

      return (
        <Box sx={
          statusIdParsed === 'IN_PROGRESS' ? { width: 'fit-content', backgroundColor: '#FEF9C3', color: '#854D0E', padding: '0 12px', borderRadius: '8px', fontWeight: '500' }
            : statusIdParsed === 'BLOCKED' ? { width: 'fit-content', backgroundColor: '#FFF4F4', color: '#C92A2A', padding: '0 12px', borderRadius: '8px', fontWeight: '500' }
              : statusIdParsed === 'DONE' ? { width: 'fit-content', backgroundColor: '#E1EFE6', color: '#388010', padding: '0 12px', borderRadius: '8px', fontWeight: '500' }
                : { width: 'fit-content', backgroundColor: 'transparent', color: '#000', padding: '0 12px', borderRadius: '8px', fontWeight: '500' }
        }>
          {capitalizeString(statusValue)} {statusIdParsed === 'IN_PROGRESS' && <CircularProgress size={10} />}
        </Box>
      );
    },
  },
  {
    accessorKey: 'type',
    header: 'Message',
  },
]
